export default "/images/Icon-user.svg?6a5967d3f36ea99b84f2db8245c4b370";